import * as React from "react";
import { inject, observer } from "mobx-react";

import { WizardHotelPWAv2HotwireView } from "./views/WizardHotelPWAv2HotwireView";
import { WizardHotelPWAv2View } from "./views/WizardHotelPWAv2View";
import { WizardHotelPWAv2HTGView } from "./views/WizardHotelPWAv2HTGView";
import { WizardHotelPWAv2Views } from "./utils/WizardHotelPWAv2Views";
import { WizardHotelPWAv2Props } from "./typings";

const getComponentFromView = (view?: string) => {
  switch (view) {
    case WizardHotelPWAv2Views.HOTWIRE:
      return WizardHotelPWAv2HotwireView;
    case WizardHotelPWAv2Views.HTG:
      return WizardHotelPWAv2HTGView;
    default:
      return WizardHotelPWAv2View;
  }
};

@inject("analytics", "experiment", "page", "wizardState", "compositionStore")
@observer
export class WizardHotelPWAv2 extends React.Component<WizardHotelPWAv2Props> {
  constructor(props: WizardHotelPWAv2Props) {
    super(props);

    const hotelWizardState = this.props.wizardState.hotelWizardState;
    const hotelWizardConfig = hotelWizardState.config;
    const isDesktop = Boolean(
      !this.props.context.deviceInformation?.mobile && !this.props.context.deviceInformation?.tablet
    );
    hotelWizardState.overrideConfig(() => {
      hotelWizardConfig.elementId = this.props.flexComponent.id;
      hotelWizardConfig.heading.fixedTitle = this.props.flexComponent.model.fixedLobTitle === false ? false : true;
      hotelWizardConfig.heading.title = this.props.flexComponent.model.lobTitle;
      hotelWizardConfig.lastSearch.useLastSearchForSingleLOB = this.props.flexComponent.model.useLastSearchForSingleLOB;
      hotelWizardConfig.includeFiltersHotelPWAWizard = this.props.flexComponent.model.includeFiltersHotelPWAWizard;
      hotelWizardConfig.analytics = this.props.analytics;
      hotelWizardConfig.enableMultiplePlaces = this.props.flexComponent.model.enableMultiplePlaces;
      hotelWizardConfig.heading.hideLobTitle = this.props.flexComponent.model.hideLobTitle;
      hotelWizardState.config.heading.lobSubtitleBreakPoint = this.props.flexComponent.model.lobSubtitleBreakPoint;
      hotelWizardConfig.siteIdsWithoutSoftPackages = this.props.flexComponent.model.siteIdsWithoutSoftPackages || [];
      hotelWizardConfig.desktopAutoOpenCalendar = Boolean(
        isDesktop && this.props.flexComponent.model.desktopAutoOpenCalendar
      );

      hotelWizardConfig.enablePackageRates =
        this.props.flexComponent.model.enablePackageRates ?? hotelWizardConfig.enablePackageRates;
      hotelWizardConfig.percentSave = this.props.flexComponent.model.percentSave ?? hotelWizardConfig.percentSave;
      hotelWizardConfig.packageRatesTermsUrl =
        this.props.flexComponent.model.packageRatesTermsUrl ?? hotelWizardConfig.packageRatesTermsUrl;
      hotelWizardConfig.showDestinationField =
        this.props.flexComponent.model.showDestinationField ?? hotelWizardConfig.showDestinationField;

      const currentSiteId = props.context?.site?.id.toString();

      if (
        hotelWizardConfig.siteIdsWithoutSoftPackages.length !== 0 &&
        hotelWizardConfig.siteIdsWithoutSoftPackages.includes(currentSiteId)
      ) {
        hotelWizardConfig.enableAddFlight = false;
        hotelWizardConfig.enableAddCar = false;
      } else {
        hotelWizardConfig.enableAddFlight = this.props.flexComponent.model.enableAddFlight;
        hotelWizardConfig.enableAddCar = this.props.flexComponent.model.enableAddCar;
      }
    });

    hotelWizardState.updateDateFromConfig();

    if (this.props.flexComponent.model.destinationFromContext) {
      hotelWizardState.updateDestinationFromContext(this.props.context);
    }
  }

  public componentDidMount() {
    const { hotelWizardState, globalWizardState } = this.props.wizardState;

    if (globalWizardState.shouldUpdateCookie) {
      hotelWizardState.updateStateFromCookie();
    }
  }

  public render() {
    const ViewComponent = getComponentFromView(this.props.flexComponent.model.view);

    return <ViewComponent {...this.props} />;
  }
}

export default WizardHotelPWAv2;
